"use client";

import { useLogger } from "@/lib/observability/LoggerContext";
import { useContext } from "react";
import { AuthContext } from "../auth-context";

export function useAuth() {
  const logger = useLogger("useAuth");
  const context = useContext(AuthContext);

  if (context === undefined) {
    const error = new Error("useAuth must be used within an AuthProvider");
    logger.logError("useAuth", error);
    throw error;
  }

  return context;
}
